// hooks/useCopyToClipboard.ts
import { useState } from "react";

export const useCopyToClipboard = (text: string) => {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    // Unused parameter paymentLinkUrl: string
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
    } catch (err) {
      console.error("Copy failed:", err);
    }
  };

  return { copied, copy };
};
